<template>
  <v-dialog :model-value="showDialog" width="auto" persistent>
    <v-card>
      <!-- Optional icon -->
      <v-card-item v-if="icon !== undefined" class="mx-auto">
        <template v-slot:prepend>
          <v-icon :icon="icon" color="pca-blue" size="large" />
        </template>
      </v-card-item>
      <v-card-text
        class="secondary-font pca-blue text-center pb-0"
        style="font-size: 14px; font-weight: 600"
        v-html="message"
      ></v-card-text>
      <v-card-text
        v-if="caption"
        class="secondary-font pca-blue text-center pb-0"
        style="font-size: 14px; font-weight: 600"
        v-html="caption"
      ></v-card-text>
      <v-card-actions
        v-if="!confirmBtnOnly"
        class="d-flex pa-6"
        :class="{ 'justify-space-between': !hideDeclineBtn, 'justify-center': hideDeclineBtn }"
      >
        <v-btn
          v-if="!hideDeclineBtn"
          :class="declineBtnColorClass"
          class="form-btn"
          @click="handleDecline"
        >
          {{ declineLabel }}
        </v-btn>
        <v-btn
          :class="confirmBtnColorClass"
          class="form-btn"
          @click="handleConfirm"
        >
          {{ confirmLabel }}
        </v-btn>
      </v-card-actions>
      <v-card-actions
        v-else
        class="d-flex justify-center pa-6"
        style="width: 100%"
      >
        <v-btn
          :class="confirmBtnColorClass"
          class="form-btn"
          @click="handleConfirm"
        >
          {{ confirmLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SimpleDialog',

  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    confirmBtnOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    message: {
      type: String,
      default: 'Are you sure?',
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
    caption: {
      type: String,
      default: '',
      required: false,
    },
    confirmLabel: {
      type: String,
      default: 'Yes',
      required: false,
    },
    confirmBtnColorClass: {
      type: String,
      default: 'pca-blue',
      required: false,
    },
    declineBtnColorClass: {
      type: String,
      default: 'pca-red',
      required: false,
    },
    declineLabel: {
      type: String,
      default: 'No',
      required: false,
    },
    hideDeclineBtn: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  emits: ['update:showDialog', 'submit', 'decline'],

  setup(props, { emit }) {
    const handleConfirm = () => {
      emit('update:showDialog', false);
      emit('submit');
    };

    const handleDecline = () => {
      emit('update:showDialog', false);
      emit('decline');
    };

    return {
      handleConfirm,
      handleDecline,
    };
  },
});
</script>

<style scoped lang="scss">
.v-card {
  max-width: 600px;
}
</style>
